import React, { useState } from "react";
import ContextApi from "../../../HOC/ContextsAPI/ContextApi";
import Layout from "../../../HOC/layout/Layout";
import AddPurchase from "../../PageComponent/Purchase/AddPurchase/AddPurchase";
import ViewPurchase from "../../PageComponent/Purchase/ViewPurchase/ViewPurchase";
import SecondaryHeader from "../../UI/SecondaryHeader/SecondaryHeader";

function Purchase() {
  const [showData, setShowData] = useState("Add");
  return (
    <ContextApi>
      <Layout>
        <div>
          <div>
            <SecondaryHeader
              setShowData={setShowData}
              showData={showData}
              addBtn="Add Purchase"
              viewBtn="View Purchase"
              // SearchText={SearchText}
            />
            {showData === "Add" ? <AddPurchase /> : <ViewPurchase />}
          </div>
        </div>
      </Layout>
    </ContextApi>
  );
}

export default Purchase;
